// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__ButtonPrimary from "../../../components/html/ButtonPrimary.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Caml_int32 from "melange.js/caml_int32.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as MelNumeral from "../../../../../../packages/util/lib/MelNumeral.js";
import * as ReasonReactRouter from "reason-react/ReasonReactRouter.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function BatchSignProgress(Props) {
  let batch = Props.batch;
  let form = Props.form;
  let stage = Props.stage;
  let completeRoute = Props.completeRoute;
  let onRestartClicked = Props.onRestartClicked;
  let progressMessage = Props.progressMessage;
  const buttonFinishRef = React.useRef(null);
  const buttonRestartRef = React.useRef(null);
  const batchCode = batch.code;
  const match = batch.owner_stats;
  const totalCount = match !== undefined ? match.sign_required_count - match.signed_count | 0 : 0;
  const totalCountLabel = MelNumeral.formatInt({
    NAME: "Int",
    VAL: totalCount
  });
  const signedCount = form.signed;
  const signedCountLabel = MelNumeral.formatInt({
    NAME: "Int",
    VAL: signedCount
  });
  const progressPercent = String(Caml_int32.div(Math.imul(signedCount, 100), totalCount));
  const fetchedPercent = String(Caml_int32.div(Math.imul(form.fetched, 100), totalCount));
  const failedCountLabel = MelNumeral.formatInt({
    NAME: "Int",
    VAL: Belt__Belt_List.length(form.sign_failed)
  });
  if (Belt__Belt_List.length(form.sign_failed) > 0) {
    console.log("sign failed", form.sign_failed);
  }
  let tmp;
  let exit = 0;
  if (/* tag */ typeof stage === "number" || typeof stage === "string") {
    switch (stage) {
      case /* Failed */ 2 :
        tmp = JsxRuntime.jsx("img", {
          className: "-ml-5",
          src: StaticAsset.src("/static/icons/batch-failure.svg")
        });
        break;
      case /* Completed */ 3 :
        tmp = JsxRuntime.jsx("img", {
          className: "-ml-5",
          src: StaticAsset.src("/static/icons/batch-success.svg")
        });
        break;
      default:
        exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx("img", {
      className: "-ml-5",
      src: StaticAsset.src("/static/icons/signature.svg")
    });
  }
  let tmp$1;
  if (/* tag */ typeof stage === "number" || typeof stage === "string") {
    switch (stage) {
      case /* Failed */ 2 :
        tmp$1 = "Ошибка";
        break;
      case /* Completed */ 3 :
        tmp$1 = "Все документы подписаны";
        break;
      default:
        tmp$1 = "Подписывается Реестр №" + batchCode;
    }
  } else {
    tmp$1 = "Подписывается Реестр №" + batchCode;
  }
  let tmp$2;
  if (/* tag */ typeof stage === "number" || typeof stage === "string") {
    switch (stage) {
      case /* Failed */ 2 :
        tmp$2 = "Соединение оборвалось, возможно, у вас отключился доступ к интернету";
        break;
      case /* Completed */ 3 :
        tmp$2 = " ";
        break;
      default:
        tmp$2 = "Не закрывайте страницу во время подписания, иначе процесс остановится";
    }
  } else {
    tmp$2 = "Не закрывайте страницу во время подписания, иначе процесс остановится";
  }
  let tmp$3;
  let exit$1 = 0;
  if (/* tag */ typeof stage === "number" || typeof stage === "string") {
    switch (stage) {
      case /* Failed */ 2 :
        tmp$3 = JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
          className: "text-center",
          children: "—"
        });
        break;
      case /* Completed */ 3 :
        tmp$3 = JsxRuntime.jsx("img", {
          alt: "success",
          src: StaticAsset.src("/static/icons/done-16.svg")
        });
        break;
      default:
        exit$1 = 1;
    }
  } else {
    exit$1 = 1;
  }
  if (exit$1 === 1) {
    tmp$3 = JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
      className: "text-center",
      children: "" + signedCountLabel + " / " + totalCountLabel
    });
  }
  let tmp$4;
  if (/* tag */ typeof stage === "number" || typeof stage === "string") {
    switch (stage) {
      case /* Failed */ 2 :
        tmp$4 = JsxRuntime.jsx(Buhta_cabinet__ButtonPrimary.make, {
          title: "Попробовать заново",
          onClick: (function (param) {
            Curry._1(onRestartClicked, undefined);
          }),
          icon: StaticAsset.src("/static/icons/refresh-white-20.svg"),
          reference: buttonRestartRef,
          className: "gap-2 px-4 py-2.5",
          textSize: "H5"
        });
        break;
      case /* Completed */ 3 :
        tmp$4 = JsxRuntime.jsx(Buhta_cabinet__ButtonPrimary.make, {
          title: "Завершить",
          onClick: (function (param) {
            ReasonReactRouter.push(Buhta_cabinet__Route.toString(completeRoute));
          }),
          icon: StaticAsset.src("/static/icons/done-white-20.svg"),
          reference: buttonFinishRef,
          className: "gap-2 px-4 py-2.5",
          textSize: "H5"
        });
        break;
      default:
        tmp$4 = null;
    }
  } else {
    tmp$4 = null;
  }
  let tmp$5;
  if (Belt__Belt_List.length(form.sign_failed) > 0) {
    const __x = form.sign_failed;
    tmp$5 = JsxRuntime.jsxs(React.Fragment, {
      children: [
        JsxRuntime.jsx(Buhta_components__Text.Label.make, {
          className: "text-asphalt mt-8",
          children: "Ошибки в реестре"
        }),
        JsxRuntime.jsx("div", {
          children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (index, item) {
            const intent = item.intent;
            const intent$1 = item.intent;
            const error = item.error;
            return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  alt: "file broken",
                  src: StaticAsset.src("/static/icons/file-broken-red-24.svg")
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "text-asphalt",
                          children: intent !== undefined ? String(intent.register_num) : ""
                        }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          children: intent$1 !== undefined ? intent$1.name : ""
                        })
                      ],
                      className: "flex gap-2"
                    }),
                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                      className: "text-alert whitespace-nowrap overflow-hidden text-ellipsis",
                      children: error !== undefined ? error.message : ""
                    })
                  ],
                  className: "space-y-1 w-[calc(100%-40px)]"
                })
              ],
              className: Cn.fromList({
                hd: "p-2 flex items-center gap-4",
                tl: {
                  hd: index === 0 ? "" : " border-t border-gray-main",
                  tl: /* [] */ 0
                }
              })
            });
          }))),
          className: "mt-4"
        })
      ]
    });
  } else {
    tmp$5 = null;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/batch.svg")
          }),
          tmp
        ],
        className: "flex items-center"
      }),
      JsxRuntime.jsx(Buhta_components__Text.H3.make, {
        className: "w-[952px] text-center",
        children: tmp$1
      }),
      JsxRuntime.jsxs("div", {
        children: [
          stage === /* Processing */ 1 ? JsxRuntime.jsx("img", {
              alt: "info",
              src: StaticAsset.src("/static/icons/info-gray-16.svg")
            }) : null,
          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: "text-asphalt text-center",
            children: tmp$2
          })
        ],
        className: "flex gap-1 items-center w-[952px] justify-center"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "h-4 bg-gray-main rounded-l-[20px] transition-all duration-300 absolute",
                style: {
                  width: "" + fetchedPercent + "%"
                }
              }),
              JsxRuntime.jsx("div", {
                className: "h-4 bg-success rounded-l-[20px] transition-all duration-300 absolute",
                style: {
                  width: "" + progressPercent + "%"
                }
              })
            ],
            className: "rounded-[20px] h-4 w-[952px] bg-gray-light batch-sign-progress relative"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: tmp$3,
                className: "border border-gray-light rounded-[40px] px-2 py-1 min-w-[56px] flex items-center justify-center"
              }),
              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                className: "text-asphalt",
                children: progressMessage
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                  className: "text-success text-center",
                  children: "" + progressPercent + "%"
                }),
                className: "border border-gray-light rounded-[40px] px-2 py-1 min-w-[56px]"
              })
            ],
            className: "flex justify-between"
          })
        ],
        className: "space-y-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                        alt: "graph",
                        src: StaticAsset.src("/static/icons/graph-gray-20.svg")
                      }),
                      JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                        className: "text-asphalt",
                        children: "Информация о реестре"
                      })
                    ],
                    className: "flex gap-2 items-center"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                            children: "" + totalCountLabel
                          }),
                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                            className: "text-asphalt",
                            children: "Всего документов"
                          })
                        ]
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                children: "" + signedCountLabel
                              }),
                              JsxRuntime.jsx("img", {
                                alt: "success",
                                src: StaticAsset.src("/static/icons/done-16.svg")
                              })
                            ],
                            className: "flex items-center gap-1"
                          }),
                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                            className: "text-asphalt",
                            children: "Подписано"
                          })
                        ]
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                children: "" + failedCountLabel
                              }),
                              JsxRuntime.jsx("img", {
                                alt: "error",
                                src: StaticAsset.src("/static/icons/close-circle-red-16.svg")
                              })
                            ],
                            className: "flex items-center gap-1"
                          }),
                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                            className: "text-asphalt",
                            children: "Ошибок"
                          })
                        ]
                      })
                    ],
                    className: "flex gap-10 items-center mt-2"
                  })
                ]
              }),
              tmp$4
            ],
            className: "flex justify-between items-center"
          }),
          tmp$5
        ],
        className: "mt-10 w-[952px] rounded-md shadow-toast p-5"
      })
    ],
    className: "py-20 flex flex-col items-center w-full gap-6"
  });
}

const make = BatchSignProgress;

export {
  make,
}
/* Buhta_cabinet__ButtonPrimary Not a pure module */
